import {replaceWithPlaceholders} from "@/utils/helper-functions"
import currencyFilter, { mdCurrencyFilter } from "@/filters/currency";
import MultiDecimalHelper from "@/utils/multi-decimal"
class TierConstructor {
    constructor(item, currencyCode, getters) {
      this.item = item;
      this.currencyCode = currencyCode;
      this.getters = getters;
      this.isMultiDecimal = MultiDecimalHelper.isMultiDecimal(item)
    }

    constructAmountSplit() {
      // TODO: HANDLE Other pricing models
        switch(this.item.pricing_model) {
            case "tiered":
            return  this.tieredDesc();
            case "stairstep":
            return this.stairstepDesc();
            case "volume":
            return this.volumeDesc();
        }
    }

    stairstepDesc() {
        let vars = {};
        vars.amount = mdCurrencyFilter(MultiDecimalHelper.getAmount(this.item), this.currencyCode);
        vars.unit = MultiDecimalHelper.getQuantity(this.item);
        let val = []
        val.push({
          desc : replaceWithPlaceholders(this.getters.get_text('line_item.desc.stairstep_pricing'), vars)
        });
        return val;
    }
    tieredDesc() {
      let tiers = this.item.tiers || [];
      if(tiers.length > 0) {
        let descriptions = [];
        tiers.forEach(tier => {
           const amount = MultiDecimalHelper.getAmount(tier);
            descriptions.push({
              desc : this.quantityDesc(MultiDecimalHelper.getUnitAmount(tier), 
              MultiDecimalHelper.getQuantity(tier), true),
              total : amount && mdCurrencyFilter(amount, this.currencyCode)
            });
        });
        return descriptions;
      }
      return [];
    }

    volumeDesc() {
      let val = []
      val.push({
        desc : this.quantityDesc(MultiDecimalHelper.getUnitAmount(this.item), 
        MultiDecimalHelper.getQuantity(this.item), true)
      });
      return val;
    }

    constructPriceInfo() {
        switch(this.item.pricing_model) {
          case "stairstep":
            return (this.stairstepDesc()[0]).desc;
          case "volume":
            return (this.volumeDesc()[0]).desc;
        }
    }

    quantityDesc(amount, quantity, appendUnits) {
        // TODO add formatting logic for multi decimal
        amount = mdCurrencyFilter(amount, this.currencyCode);
        let units = quantity;
        if(appendUnits) {
            units += " " + (this.getters.get_text('line_item.desc.units') || '');
        }
        return amount + " &times; " + units ;
    }
}

export default {
    
    hasTieredPricing(items) {
        return items.some(i => (i.type == "plan" || i.type == "addon") ? (i.pricing_model == "tiered"): false);
    },

    canShowAmountSplit(item) {
        switch(item.type) {
            case "plan":
            case "addon":
            return ["tiered", "stairstep", "volume"].indexOf(item.pricing_model) != -1;
        }
    },

    getTierConstructor(item, currencyCode, getters) {
        return new TierConstructor(item, currencyCode, getters);
    }
}